export const testScriptDeleteTableColumns: any = [
  {
    display_name: "Test Script Name",
    key: "name",
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "40%",
    },
  },
  {
    display_name: "Affected Test Plans",
    key: "testPlan.name",
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "40%",
    },
  },
];

export const testSuiteDeleteTableColumns: any = [
  {
    display_name: "Test Script Name",
    key: "name",
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Test Suite Name",
    key: "script.automationScriptGroup.name",
    headerStyles: {
      background: "#7593F2",
      width: "30%",
    },
  },
  {
    display_name: "Affected Test Plans",
    key: "testPlan.name",
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "30%",
    },
  },
];
